import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
  canonicalPath?: string;
  ogImage?: string;
}

const BASE_URL = 'https://www.lot20.coffee';

export const usePageMeta = ({ title, description, canonicalPath, ogImage }: PageMeta) => {
  useEffect(() => {
    const fullTitle = title.includes('Lot 20') ? title : `${title} | Lot 20 Coffee`;
    document.title = fullTitle;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', fullTitle);

    const twitterDesc = document.querySelector('meta[property="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', description);

    // Update OG image — use per-page image or fall back to default
    const finalImage = ogImage || `${BASE_URL}/og-image.webp`;
    const ogImg = document.querySelector('meta[property="og:image"]');
    if (ogImg) ogImg.setAttribute('content', finalImage);
    const twitterImg = document.querySelector('meta[property="twitter:image"]');
    if (twitterImg) twitterImg.setAttribute('content', finalImage);

    if (canonicalPath) {
      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = `${BASE_URL}${canonicalPath}`;

      // Also set og:url
      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute('content', `${BASE_URL}${canonicalPath}`);
    }
  }, [title, description, canonicalPath, ogImage]);
};
